/**
 * A global namespace for touch events.
 * @type {Record<string, string>}
 */
const touchEvents = {
  start: 'touchstart', end: 'touchend', move: 'touchmove', cancel: 'touchcancel',
};
export default touchEvents;



//////////////////
// WEBPACK FOOTER
// ./node_modules/shorter-js/src/strings/touchEvents.js
// module id = 9
// module chunks = 0